<template>
  <Modal
    v-model="innerShow"
    :title="title"
    :width="'500px'"
    :mask-closable="false"
    @on-ok="confirm"
    @on-cancel="close"
    @on-visible-change="show"
    class="yjh-diag yjh-diag--upload vertical-center-modal">
      <div class="upload-diag-content">
        <Upload
          ref="uploadxlsx"
          :max-size="innerMaxSize"
          :on-exceeded-size="overSizeFn"
          :on-progress="uploading"
          :on-error="uploadError"
          :before-upload="handleUpload"
          :on-success="uploadSuccess"
          type="drag"
          :action="uploadaction"
          :headers="uploadheaders"
        >
          <div class="upload-diag-body" v-loading="loading">
            <i class="yjh-icon icon-upload"></i>
            <template v-if="!error && !success">
              <p class="upload-text link-btn">点击上传</p>
            </template>
            <template v-else-if="success">
              <p class="upload-filename">{{file.name || ''}}</p>
              <p class="upload-text link-btn">重新上传</p>
            </template>
            <template v-else>
              <p class="upload-text">
                <i class="yjh-icon icon-error"></i>上传失败，请 <span class="link-btn">重新上传</span>
              </p>
            </template>
            <p class="upload-tips">只支持模板上传 ({{maxSize}}M以内)</p>
          </div>
        </Upload>
        <div class="upload-template link-btn">
          <a href="javascript:;" @click="downloadexcel">下载模板</a>
        </div>
      </div>
      <template slot="footer">
        <Button @click="close">取消</Button>
        <Button @click="confirm" type="primary">确定</Button>
      </template>
    </Modal>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      loading: false,
      innerShow: false,
      error: false,
      success: false,
      file: null, // 上传的文件
      uploadheaders: {
        'YJHTOKEN': localStorage.getItem('token')
      }
    }
  },
  props: {
    maxSize: {
      type: Number,
      default: 10
    },
    isShow: Boolean,
    title: {
      type: String,
      default: '提示'
    },
    content: String,
    html: {
      type: Boolean,
      default: false
    },
    uploadaction: {
      type: String,
      default: ''
    }
  },
  computed: {
    innerMaxSize() {
      return this.maxSize * 1024
    }
  },
  watch: {
    isShow() {
      this.innerShow = this.isShow
    }
  },
  mounted() {
    this.innerShow = this.isShow
  },
  methods: {
    // 文件超大
    overSizeFn(file) {
      this.$Message.info('文件不超过10M')
    },
    // 上传中
    uploading() {
      this.loading = true
    },
    // 上传出错
    uploadError() {
      this.loading = false
      this.error = true
    },
    initupload() {
      this.error = false
      this.success = false
    },
    // 上传前的钩子
    handleUpload(file) {
      this.initupload()
      const fileType = file.name.split('.')[1]
      const fileSize = file.size
      if (!['xlsx', 'xls'].includes(fileType)) {
        this.$Message.info('上传文件格式不正确！')
        return false
      }
      if (fileSize >= this.innerMaxSize) {
        this.$Message.info('上传文件格式超过10M')
        return false
      }
      this.file = file
      this.success = true
      return false
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.loading = false
      if (res.code === 0) {
        this.$emit('close')
      } else {
        this.error = true
      }
    },
    close() {
      this.$emit('close')
    },
    confirm() {
      if (!this.file) {
        this.$Message.info('上传文件不能为空！')
        return ''
      }
      this.$refs.uploadxlsx.post(this.file)
    },
    show(flag) {
      if (flag) {
        this.$emit('show')
      } else {
        this.$emit('hide')
      }
    },
    downloadexcel() { // 这个是使用后台接口 获得excel表格的方法
      axios.get(process.env.VUE_APP_BASE_API + '/standard/download_user_import_demo', {
        crossDomain: true,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencode',
          'YJHTOKEN': localStorage.getItem('token')
        },
        responseType: 'blob'
      }).then(res => {
        if (res.status !== 200) {
          this.$Message.info('下载模板失败！')
          return ''
        }
        const string = res.headers['content-disposition']
        const demoName = string.split(';').pop().slice(18)
        var blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob)
        downloadElement.href = href
        downloadElement.download = decodeURI(demoName)
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
        window.URL.revokeObjectURL(href)
      })
    }
  }
}
</script>
<style lang="scss">
  .upload-diag-content {
    width: 400px;
    margin: 0 auto;
    .ivu-upload-drag {
      width: 400px;
      height:200px;
      border: 1px solid #BECAD6;
    }
    .upload-diag-body {
      padding: 42px;
      border-radius: 4px;
    }
    .upload-text {
      display: block;
      margin: 16px 0;
      line-height: 12px;
      &.link-btn {
        text-decoration: underline;
      }
      .link-btn {
        line-height: 14px;
      }
      .yjh-icon {
        vertical-align: sub;
      }
    }
    .upload-filename {
      color: #373d41;
      line-height: 12px;
      margin-top: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      & + .upload-text {
        margin-top: 14px;
      }
    }
    .upload-tips {
      line-height: 12px;
      color: #9B9EA0;
    }
    .upload-template {
      line-height: 12px;
      text-align: right;
      display: block;
      margin-top: 12px;
    }
  }
</style>
